import { render, staticRenderFns } from "./GalleryItem.vue?vue&type=template&id=5296f020&scoped=true&"
import script from "./GalleryItem.vue?vue&type=script&lang=js&"
export * from "./GalleryItem.vue?vue&type=script&lang=js&"
import style0 from "./GalleryItem.vue?vue&type=style&index=0&id=5296f020&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5296f020",
  null
  
)

export default component.exports